module.exports = __webpack_public_path__ + "static/alix-245b25a1f31b0a7e252adc59a1c9f917.png";